import { CapoPlugin } from "/home/forge/oase-aej.de/releases/82168262/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];